import script from "./ModalBodyButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalBodyButtons.vue?vue&type=script&setup=true&lang=js"

import "./ModalBodyButtons.vue?vue&type=style&index=0&id=6788e0e2&lang=scss&scoped=true"

import exportComponent from "/var/www/rayband/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6788e0e2"]])

export default __exports__